import WebfontLoader from "webfontloader";

export class WebfontFile extends Phaser.Loader.File {

    private _loadedCount: number;
    private _fontNames: string[];
    private _service: FontService;

    constructor(loader: Phaser.Loader.LoaderPlugin, service: FontService, fontNames: string[]) {
        super(loader, {
            type: 'webfont',
            key: fontNames.toString()
        });
        this._loadedCount = 0;
        this._fontNames = fontNames;
        this._service = service;
    }

    load(): void {
        const config: WebfontLoader.Config = {
            fontactive: (name: string) => {
                this._checkLoaded(name);
            },
            fontinactive: (name: string) => {
                this._checkLoaded(name);
            },
        }

        if (this._service === "google") {
            config["google"] = {
                families: this._fontNames
            }
        }

        WebfontLoader.load(config);
    }

    private _checkLoaded(name: string) {
        if (!this._fontNames.includes(name)) {
            return;
        }
        this._loadedCount++;
        if (this._loadedCount >= this._fontNames.length) {
            this.loader.nextFile(this, true);
        }
    }
}

export type FontService = "google";